import SpHeader from '@/views/layout/sp/Header';
import SpFooter from '@/views/layout/sp/Footer';

import { Role } from '@/helpers/role';

import SpLogin from '@/views/components/sp/Login/Login';
import SpResetPassword from '@/views/components/sp/ResetPassword/ResetPassword';

import SpVoucherList from '@/views/components/sp/Voucher/List';
import SpDetailVoucher from '@/views/components/sp/Voucher/Detail';
import SpEditVoucher from '@/views/components/sp/Voucher/Edit';
import SpAddVoucher from '@/views/components/sp/Voucher/Add';

import SpImageVoucher from '@/views/components/sp/Voucher/Image';
import SpImageMultiVoucher from '@/views/components/sp/Voucher/ImageMulti';
import SpCameraPreProcessingVoucher from '@/views/components/sp/Voucher/CameraPreProcessing';

import SpInputTour from '@/views/components/sp/Tour/Input';
import SpAfterInputTour from '@/views/components/sp/Tour/AfterInput';
import SpVoucherContracts from '@/views/components/sp/Voucher/Contracts';
import SpSelectContract from '@/views/components/sp/Voucher/SelectContract';
import SpSubContracts from '@/views/components/sp/Voucher/SubContract';
import SpLoginFirstMfa from '@/views/components/sp/Login/LoginFirstMfa';
import SpLoginMfa from '@/views/components/sp/Login/LoginMfa';

const routerSP = [
    {
        path: '/login',
        name: 'SpLogin',
        components: {
            // spheader: SpHeader,
            spbody: SpLogin,
            spfooter: SpFooter,
        },
        meta: {
            public: true,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/login/mfa/first',
        name: 'SpLoginFirstMfa',
        components: {
            spbody: SpLoginFirstMfa,
            spfooter: SpFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.PwReset.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/login/mfa',
        name: 'SpLoginMfa',
        components: {
            spbody: SpLoginMfa,
            spfooter: SpFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.PwReset.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/',
        redirect: '/tour/input',
        name: 'Home',
        components: {},
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/changepassword',
        name: 'SpResetPassword',
        components: {
            // spheader: SpHeader,
            spbody: SpResetPassword,
            spfooter: SpFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/tour/input',
        name: 'SpInputTour',
        components: {
            spheader: SpHeader,
            spbody: SpInputTour,
            spfooter: SpFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/tour/after-input',
        name: 'SpAfterInputTour',
        components: {
            spheader: SpHeader,
            spbody: SpAfterInputTour,
            spfooter: SpFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/voucher/list',
        name: 'SpVoucherList',
        components: {
            spheader: SpHeader,
            spbody: SpVoucherList,
            spfooter: SpFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/voucher/contracts',
        name: 'SpVoucherContracts',
        components: {
            spheader: SpHeader,
            spbody: SpVoucherContracts,
            spfooter: SpFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/voucher/subContracts',
        name: 'SpSubContracts',
        components: {
            spheader: SpHeader,
            spbody: SpSubContracts,
            spfooter: SpFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/voucher/selectContract',
        name: 'SpSelectContract',
        components: {
            spheader: SpHeader,
            spbody: SpSelectContract,
            spfooter: SpFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/voucher/detail',
        name: 'SpDetailVoucher',
        components: {
            spheader: SpHeader,
            spbody: SpDetailVoucher,
            spfooter: SpFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/voucher/edit',
        name: 'SpEditVoucher',
        components: {
            spheader: SpHeader,
            spbody: SpEditVoucher,
            spfooter: SpFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/voucher/image',
        name: 'SpImageVoucher',
        components: {
            spheader: SpHeader,
            spbody: SpImageVoucher,
            spfooter: SpFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/voucher/image-multi',
        name: 'SpImageMultiVoucher',
        components: {
            spheader: SpHeader,
            spbody: SpImageMultiVoucher,
            spfooter: SpFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/voucher/camera-pre',
        name: 'SpCameraPreProcessingVoucher',
        components: {
            spheader: SpHeader,
            spbody: SpCameraPreProcessingVoucher,
            spfooter: SpFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id],
        },
    },
    {
        path: '/voucher/add',
        name: 'SpAddVoucher',
        components: {
            spheader: SpHeader,
            spbody: SpAddVoucher,
            spfooter: SpFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.ReadOnly.id],
        },
    },

];

export default routerSP;



// WEBPACK FOOTER //
// ./src/router/sp.js